import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IListResponseData, PLATFORM, Platform, SERVICES_API } from '@pro-connect/shared';
import { Observable } from 'rxjs';
import { ITrainingsList } from 'shared/src/pages/core/models/trainings-list';
import { ITrainingsListDto } from 'shared/src/pages/core/models/trainings-list-dto';

@Injectable({
  providedIn: 'root',
})
export class ProEducationService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    @Inject(PLATFORM)
    private readonly _platform: Platform,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Get a list of trainings
   * @param dto
   */
  public getTrainings(dto: ITrainingsListDto): Observable<IListResponseData<ITrainingsList>> {
    const dtoWithRemovedBlankFields = Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null));
    return this._httpClient.get<IListResponseData<ITrainingsList>>(
      `${this._servicesApi}/pro/edu/training/${this._platform}/list`,
      {
        params: {
          ...dtoWithRemovedBlankFields,
        },
        withCredentials: true,
      },
    );
  }

  /**
   * Get a list of trainings categories
   */
  public getTrainingsCategories(): Observable<{ id: number; name: string }[]> {
    return this._httpClient.get<{ id: number; name: string }[]>(`${this._servicesApi}/pro/edu/category/list`, {
      withCredentials: true,
    });
  }

  /**
   * Get a list of trainings places
   */
  public getTrainingsPlaces(): Observable<{ id: number; name: string }[]> {
    return this._httpClient.get<{ id: number; name: string }[]>(`${this._servicesApi}/pro/edu/place/list`, {
      withCredentials: true,
    });
  }
}
